import { useQuery } from '@tanstack/react-query';
import { loadModuleFlagMap } from '@pc/db';
import { useActiveCtx } from './useCtx';

/** Whether a module (e.g. shipping) is enabled for the active org. */
export function useModuleEnabled(moduleId: string): boolean | undefined {
  const { orgId } = useActiveCtx();
  const q = useQuery({
    queryKey: ['moduleFlags', orgId],
    queryFn: () => loadModuleFlagMap(orgId),
    enabled: Boolean(orgId),
  });
  return q.data?.isEnabled(moduleId);
}
